import { useState } from "react";
import { useSelector } from "react-redux";
import checkIfEnable from "../../../utils/checkIfEnable";
import ServiceIDByLabel from "../../../services/ServiceIDByLabel";
import SVGComponent from "../../_utils/SVGComponent";

const MenuItemCard = ({ icon, label }) => {
  const [showExpandArrow, setShowExpandArrow] = useState(false);
  const services_list = useSelector((state) => state.refreshToken.services);
  const isEnabled = checkIfEnable(ServiceIDByLabel, label, services_list);

  return (
    <div
      className={`flex gap-gap-sm flex-grow items-center justify-between p-padding-sm rounded-border-radius-l ${
        isEnabled
          ? "cursor-pointer global-hover-blue relative z-z-index-base"
          : "pointer-events-none"
      }`}
      onMouseEnter={() => setShowExpandArrow(true)}
      onMouseLeave={() => setShowExpandArrow(false)}
    >
      <div className="flex flex-row items-center gap-x-gap-md">
        {icon && (
          <img
            className="w-icon-lg h-icon-lg"
            src={icon}
            alt=""
          />
        )}
        <p className="text-font-md text-primary-bg font-normal">{label}</p>
      </div>
      <div
        style={{
          flexShrink: "0",
          visibility: showExpandArrow ? "visible" : "hidden",
        }}
      >
        <SVGComponent
          url={
            "https://q2pay.in/new_assets/common/arrows/arrow_right_white.svg"
          }
          width={"var(--icon-sm"}
          height={"var(--icon-sm"}
          color={"var(--primary-bg)"}
        />
      </div>
    </div>
  );
};

export default MenuItemCard;
